import * as i from 'types';

export const isSerie = (item: i.Serie | i.Class): item is i.Serie => 'attendanceId' in item;
